// extracted by mini-css-extract-plugin
module.exports = {"Loading":"loading_Loading__nqZOu","Loading__WrapperDots":"loading_Loading__WrapperDots__o0qoe","Loading__Dots":"loading_Loading__Dots__FnD63","move":"loading_move__W6Tnh"};